module.exports = __webpack_public_path__ + "static/media/wv.20f6146f.svg";